"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNewsletterThankYouMockData = exports.buildNewsletterSignupConfirmationMockData = exports.buildInvoiceReminderMockData = exports.buildNewMembershipCardMockData = exports.buildMemberCardMockData = exports.buildMembersOnlyNotEligibleMockData = exports.buildReceiptCancelledDonorMockData = exports.buildContactFacingBase = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const sign_up_thank_you_email_1 = require("../../internationalization/locales/sign-up-thank-you-email");
const icons_1 = require("../icons");
const organization_facing_base_1 = require("./organization-facing-base");
const buildContactFacingBase = ({ organizationName, color, isDarkMode, locale = "en", subject, }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    return {
        theme,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        labels: (0, email_templates_1.getEmailLabels)(locale),
        lang: locale,
        isPreview: false,
        subject,
        orgName: organizationName || "Bright Futures Foundation",
    };
};
exports.buildContactFacingBase = buildContactFacingBase;
const buildReceiptCancelledDonorMockData = ({ subject = "Your tax receipt has been cancelled", firstName = "Jane", fileUrl = "https://storage.zeffy.com/receipts/cancelled-receipt.pdf", ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, subject }),
    firstName,
    fileUrl,
});
exports.buildReceiptCancelledDonorMockData = buildReceiptCancelledDonorMockData;
const buildMembersOnlyNotEligibleMockData = ({ subject = "Continue your purchase", campaignName = "Sandbox Gala", campaignLink = "https://www.zeffy.com/en-US/ticketing/sandbox-gala", ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, subject }),
    campaignName,
    campaignLink,
});
exports.buildMembersOnlyNotEligibleMockData = buildMembersOnlyNotEligibleMockData;
const buildMemberCardMockData = ({ subject = "Your Bright Futures Foundation member card is ready", firstName = "Sammy", buyerName = "Jane Smith", membershipType = "Annual Family Membership", cardUrl = "https://storage.zeffy.com/e-tickets/member-card.pdf", message = "<p>Hi Sammy,</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Warm regards,</p><p><strong>The Bright Futures Foundation Team</strong></p>", ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, subject }),
    firstName,
    buyerName,
    membershipType,
    cardUrl,
    message,
});
exports.buildMemberCardMockData = buildMemberCardMockData;
const buildNewMembershipCardMockData = ({ subject = "Your new member card is ready", firstName = "Jane", eTicketUrl = "https://storage.zeffy.com/e-tickets/member-card.pdf", ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, subject }),
    firstName,
    eTicketUrl,
});
exports.buildNewMembershipCardMockData = buildNewMembershipCardMockData;
const INVOICE_REMINDER_SUBJECT = {
    immediate: "A new invoice from Bright Futures Foundation was created",
    beforeDue: "Your invoice from Bright Futures Foundation is due on March 14, 2026",
    onDueDate: "Your invoice from Bright Futures Foundation is due today",
    overdue: "Your invoice from Bright Futures Foundation is overdue",
};
const buildInvoiceReminderMockData = ({ reminderType = "immediate", subject = INVOICE_REMINDER_SUBJECT[reminderType], firstName = "Jane", invoicePrice = "$250.00", dueDate = "March 14, 2026", invoiceUrl = "https://www.zeffy.com/invoice/sandbox-invoice", ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, subject }),
    reminderType,
    firstName,
    invoicePrice,
    dueDate,
    invoiceUrl,
});
exports.buildInvoiceReminderMockData = buildInvoiceReminderMockData;
const NEWSLETTER_SIGNUP_CONFIRMATION_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Please confirm your newsletter signup",
    [locales_1.Locales.FR]: "Veuillez confirmer votre inscription à l'infolettre",
    [locales_1.Locales.ES]: "Confirme su suscripción al boletín",
    [locales_1.Locales.DE]: "Bitte bestätigen Sie Ihre Newsletter-Anmeldung",
});
// A snapshot of the checkbox the subscriber ticked, so it is org-authored copy — written per locale, not translated.
const NEWSLETTER_CONSENT_WORDING = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "Yes, I would like to receive the newsletter from Bright Futures Foundation by email. I can withdraw my consent at any time.",
    [locales_1.Locales.FR]: "Oui, je souhaite recevoir l'infolettre de Bright Futures Foundation par courriel. Je peux retirer mon consentement à tout moment.",
    [locales_1.Locales.ES]: "Sí, deseo recibir el boletín de Bright Futures Foundation por correo electrónico. Puedo retirar mi consentimiento en cualquier momento.",
    [locales_1.Locales.DE]: "Ja, ich möchte den Newsletter von Bright Futures Foundation per E-Mail erhalten. Ich kann meine Einwilligung jederzeit widerrufen.",
});
// The send site formats this in the recipient's locale, so the mock ships it pre-formatted.
const NEWSLETTER_SIGNED_UP_AT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "August 18, 2026 at 2:32 PM (CEST)",
    [locales_1.Locales.FR]: "18 août 2026 à 14 h 32 (CEST)",
    [locales_1.Locales.ES]: "18 de agosto de 2026 a las 14:32 (CEST)",
    [locales_1.Locales.DE]: "18. August 2026 um 14:32 Uhr (MESZ)",
});
const buildNewsletterSignupConfirmationMockData = ({ locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(NEWSLETTER_SIGNUP_CONFIRMATION_SUBJECT, locale), firstName = "Anna", contactEmail = "anna.schmidt@example.de", confirmationLink = "https://www.zeffy.com/de/newsletter/confirm?token=sandbox-token", expiryHours = "72", consentWording = (0, organization_facing_base_1.pickForLocale)(NEWSLETTER_CONSENT_WORDING, locale), signedUpAt = (0, organization_facing_base_1.pickForLocale)(NEWSLETTER_SIGNED_UP_AT, locale), ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, locale, subject }),
    firstName,
    contactEmail,
    confirmationLink,
    expiryHours,
    consentWording,
    signedUpAt,
});
exports.buildNewsletterSignupConfirmationMockData = buildNewsletterSignupConfirmationMockData;
const buildNewsletterThankYouMockData = ({ locale = "en", subject = (0, sign_up_thank_you_email_1.getSignUpThankYouEmailSubject)((0, locales_2.getLocalesFromIsoLocale)(locale)), firstName = "John", message = (0, sign_up_thank_you_email_1.getSignUpThankYouEmailBody)({
    locale: (0, locales_2.getLocalesFromIsoLocale)(locale),
    signerName: "Victor Birchler",
}), ...base }) => ({
    ...(0, exports.buildContactFacingBase)({ ...base, locale, subject }),
    firstName,
    message,
});
exports.buildNewsletterThankYouMockData = buildNewsletterThankYouMockData;
